(() => {
  const doc = document;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const activateMedia = (root, index, shouldFocus = false) => {
    const media = [...root.querySelectorAll('[data-po-product-media]')];
    if (!media.length) return;
    const normalized = Math.max(0, Math.min(Number(index) || 0, media.length - 1));
    media.forEach((item, itemIndex) => {
      const active = itemIndex === normalized;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-hidden', String(!active));
    });
    root.querySelectorAll('[data-v2-gallery-thumb],[data-v2-gallery-dot]').forEach((control) => {
      control.setAttribute('aria-current', String(Number(control.dataset.mediaIndex) === normalized));
    });
    if (shouldFocus) media[normalized].querySelector('[data-po-media-open]')?.focus({ preventScroll: true });
  };

  doc.querySelectorAll('[data-v2-product]').forEach((productRoot) => {
    productRoot.querySelectorAll('[data-v2-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => activateMedia(productRoot, thumb.dataset.mediaIndex));
      thumb.addEventListener('mouseenter', () => {
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) activateMedia(productRoot, thumb.dataset.mediaIndex);
      });
    });
    productRoot.querySelectorAll('[data-v2-gallery-dot]').forEach((dot) => dot.addEventListener('click', () => {
      const target = productRoot.querySelector(`[data-po-product-media][data-media-index="${dot.dataset.mediaIndex}"]`);
      target?.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', inline: 'center', block: 'nearest' });
    }));
    productRoot.querySelectorAll('[data-po-variant-option]').forEach((option) => option.addEventListener('change', () => {
      if (!option.dataset.mediaId) return;
      const target = productRoot.querySelector(`[data-po-product-media][data-media-id="${option.dataset.mediaId}"]`);
      if (target) activateMedia(productRoot, target.dataset.mediaIndex);
    }));
  });

  doc.querySelectorAll('.po-v2-card').forEach((card) => {
    const selected = card.querySelector('[data-po-card-selected]');
    card.querySelectorAll('[data-po-card-variant]').forEach((button) => button.addEventListener('click', () => {
      if (selected) selected.textContent = button.textContent.trim();
    }));
  });

  const initializeRelatedCarousel = (root) => {
    if (!root || root.dataset.relatedCarouselReady === 'true') return;
    const track = root.querySelector('[data-related-track]');
    const previous = root.querySelector('[data-related-prev]');
    const next = root.querySelector('[data-related-next]');
    if (!track || !previous || !next) return;

    root.dataset.relatedCarouselReady = 'true';
    const updateControls = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll - 2;
    };
    const scrollCards = (direction) => {
      const card = track.querySelector('.comparison-product');
      const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
      const amount = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      track.scrollBy({ left: direction * amount, behavior: reducedMotion ? 'auto' : 'smooth' });
    };

    previous.addEventListener('click', () => scrollCards(-1));
    next.addEventListener('click', () => scrollCards(1));
    track.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls, { passive: true });
    updateControls();
  };

  doc.querySelectorAll('[data-related-carousel]').forEach(initializeRelatedCarousel);
  doc.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-related-carousel]').forEach(initializeRelatedCarousel);
  });

  doc.querySelectorAll('.po-product__accordion details, .detail-accordions details, .po-v2-product-details__description').forEach((details) => {
    const summary = details.querySelector('summary');
    if (!summary) return;
    summary.setAttribute('aria-expanded', String(details.open));
    details.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(details.open)));
  });
})();
